// src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute: React.FC = () => {
    const { user } = useAuth();

    // if (isLoading) {
    //     return <div>Cargando...</div>;
    // }

    return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute; 